import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { postStartBreakText } from 'Const/monitoring/domain';
import postAcceptRequest from 'Api/host-help-partner/postAcceptRequest';

import postAcceptRequestPayload from './model/request/postAcceptRequestPayload';

const usePostAcceptRequest = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const queryClient = useQueryClient();

  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = postAcceptRequestPayload(formData);

      const result = await postAcceptRequest(payload);

      return result;
    },
    onMutate: () => onShowLoader({ variant: 'loader-primary' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['monitoring-operator-status'] });
      await queryClient.invalidateQueries({ queryKey: ['help-request-operator-status'] });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : postStartBreakText.defaultErrorMessageText;
      onOpenToast({ status: 'error', description: errorMessage, duration: 5, alwaysShow: false });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostAcceptRequest;
